export const TRANSACTION_STATUSES_MAP = {
  accept: 3,
  reject: 4,
} as const;

export const transactionStatusNeedsReviewAndPendingValidation = 13;
export const transactionStatusNeedsReviewAndValidated = 14;
